/**
 * Delegated click handler + auto-pause for inline primary videos.
 * Works with any .inline-video-play-pause button inside a deferred-media or .has-inline-video element.
 */

const AUTO_PAUSE_DELAY = 5000;

/** @param {HTMLVideoElement} video */
function findPlayPauseBtn(video) {
  const container = video.closest('deferred-media') || video.closest('.has-inline-video');
  return container ? container.querySelector('.inline-video-play-pause') : null;
}

// Auto-pause after 5 seconds for all managed videos.
// Uses capture phase because 'play'/'pause' events don't bubble.
document.addEventListener(
  'play',
  (event) => {
    const video = event.target;
    if (!(video instanceof HTMLVideoElement)) return;

    // Only manage videos inside our containers
    const container = video.closest('deferred-media') || video.closest('.has-inline-video');
    if (!container) return;

    if (video._autoPauseTimer) clearTimeout(video._autoPauseTimer);

    video._autoPauseTimer = setTimeout(() => {
      video.pause();
      const btn = findPlayPauseBtn(video);
      if (btn) {
        btn.dataset.state = 'paused';
        btn.setAttribute('aria-label', 'Play video');
      }
    }, AUTO_PAUSE_DELAY);
  },
  true
);

document.addEventListener(
  'pause',
  (event) => {
    const video = event.target;
    if (!(video instanceof HTMLVideoElement)) return;

    if (video._autoPauseTimer) {
      clearTimeout(video._autoPauseTimer);
      video._autoPauseTimer = null;
    }
  },
  true
);

// Play/pause button click handler
document.addEventListener('click', (event) => {
  const btn = event.target.closest('.inline-video-play-pause');
  if (!btn) return;

  const media = btn.closest('deferred-media') || btn.closest('.has-inline-video');
  if (!media) return;

  const video = media.querySelector('video');
  if (!video) return;

  if (video.paused) {
    video.play();
    btn.dataset.state = 'playing';
    btn.setAttribute('aria-label', 'Pause video');
  } else {
    video.pause();
    btn.dataset.state = 'paused';
    btn.setAttribute('aria-label', 'Play video');
  }
});
